module.exports = __webpack_public_path__ + "img/Marketing-OnlineDAC.b06167f4.svg";